import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }

import { computed, ref } from 'vue';
import { formatDate } from '@/utils/date-utils';
import { SampleType } from '@/gql/graphql';
import SampleDetail from '@/components/sample/SampleDetail.vue';
import SampleForm from '@/components/sample/SampleForm.vue';
import SampleDelete from '@/components/sample/SampleDelete.vue';
import ProjectSampleAssociationDelete from '@/components/project/ProjectSampleAssociationDelete.vue';
import {
  BAlert,
  BButton,
  BButtonGroup,
  BCard,
  BTable,
} from 'bootstrap-vue-next';

// --- Extended Sample Inteface ---
export interface SampleTypeExtended extends SampleType {
  canEdit: boolean;
}

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'SampleList',
  props: {
    samples: {},
    loading: { type: Boolean },
    showBucket: { type: Boolean },
    showKit: { type: Boolean },
    showAssociatedProjects: { type: Boolean },
    assocProjectId: {},
    assocProjectName: {},
    canEditSampleAssoc: { type: Boolean }
  },
  emits: ['refresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const noSamples = computed(() => {
  return props.samples.length === 0;
});

// --- Component emits ---
const emits = __emit;

// --- Sample selection (details, edit, delete, create) ---
const selectedSample = ref<SampleType | null>(null);
const showModalSampleDetail = ref(false);
const showModalSampleEdit = ref(false);
const showModalSampleDelete = ref(false);
const showModalProjectSampleAssociationDelete = ref(false);

// --- Handle sample actions ---
function handleSampleDetailRequest(sample: SampleType) {
  console.debug('Sample details requested:', sample.name);
  selectedSample.value = sample;
  showModalSampleDetail.value = true;
}

function handleSampleEditRequest(sample: SampleType) {
  console.debug('Sample edit requested:', sample.name);
  selectedSample.value = sample;
  showModalSampleEdit.value = true;
}

function handleSampleDeleteRequest(sample: SampleType) {
  console.debug('Sample deletion requested:', sample.name);
  selectedSample.value = sample;
  showModalSampleDelete.value = true;
}

function handleSampleProjectAssociationDeleteRequest(sample: SampleType) {
  console.debug('Sample project association deletion requested:', sample.name);
  selectedSample.value = sample;
  showModalProjectSampleAssociationDelete.value = true;
}

function onSampleFormSuccess() {
  closeModals();
  emits('refresh');
}

function onSampleDeleteSuccess() {
  closeModals();
  emits('refresh');
}

function onProjectSampleAssociationDeleteSuccess() {
  closeModals();
  emits('refresh');
}

function closeModals() {
  selectedSample.value = null;

  showModalSampleDetail.value = false;
  showModalSampleEdit.value = false;
  showModalSampleDelete.value = false;
  showModalProjectSampleAssociationDelete.value = false;
}
// --- Sample Table Fields ---
const sampleTableFields = computed(() => {
  // First define fields that are always present
  const fields = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      tdClass: 'align-middle',
    },
    {
      key: 'description',
      label: 'Description',
      sortable: true,
      tdClass: 'align-middle',
    },
    {
      key: 'createdAt',
      label: 'Created',
      sortable: true,
      formatter: formatDate,
      tdClass: 'align-middle',
    },
    { key: 'id', label: '', tdClass: 'align-middle text-end min-width' },
  ];
  // Kit field (optional)
  if (props.showKit) {
    fields.splice(2, 0, {
      key: 'kit',
      label: 'Kit',
      sortable: true,
      tdClass: 'align-middle',
    });
  }
  // Bucket field (optional)
  if (props.showBucket) {
    fields.splice(2, 0, {
      key: 'bucket.friendlyName',
      label: 'Data Bucket',
      sortable: true,
      tdClass: 'align-middle',
    });
  }
  return fields;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: noSamples.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((noSamples).value = $event)),
      variant: "secondary"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("No samples found.", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"]),
    (props.samples.length > 0)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BTable), {
              items: props.samples,
              busy: __props.loading,
              fields: sampleTableFields.value,
              small: "",
              striped: "",
              responsive: "",
              hover: "",
              class: "browser-table",
              onRowClicked: handleSampleDetailRequest
            }, {
              "cell(name)": _withCtx((data) => [
                _createElementVNode("strong", null, _toDisplayString(data.value), 1)
              ]),
              "cell(kit)": _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.value.name) + " (" + _toDisplayString(data.value.code.code) + ") ", 1)
              ]),
              "cell(id)": _withCtx((data) => [
                _createVNode(_unref(BButtonGroup), { class: "action-buttons" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      size: "sm",
                      variant: "outline-secondary",
                      onClick: ($event: any) => (handleSampleDetailRequest(data.item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "magnifying-glass" })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (props.assocProjectId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (props.canEditSampleAssoc)
                            ? _withDirectives((_openBlock(), _createBlock(_unref(BButton), {
                                key: 0,
                                size: "sm",
                                variant: "outline-secondary",
                                onClick: ($event: any) => (handleSampleProjectAssociationDeleteRequest(data.item)),
                                id: `btn-remove-sample-assoc-${data.item.id}`,
                                title: "Remove sample from project"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    id: `icon-remove-project-sample-assoc-${data.item.id}`,
                                    icon: "xmark"
                                  }, null, 8, ["id"])
                                ]),
                                _: 2
                              }, 1032, ["onClick", "id"])), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (data.item.canEdit)
                            ? (_openBlock(), _createBlock(_unref(BButton), {
                                key: 0,
                                size: "sm",
                                variant: "outline-secondary",
                                onClick: ($event: any) => (handleSampleEditRequest(data.item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "pencil" })
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (data.item.canEdit)
                            ? (_openBlock(), _createBlock(_unref(BButton), {
                                key: 1,
                                size: "sm",
                                variant: "outline-secondary",
                                onClick: ($event: any) => (handleSampleDeleteRequest(data.item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "trash" })
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["items", "busy", "fields"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (selectedSample.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(SampleDetail, {
            sample: selectedSample.value,
            show: showModalSampleDetail.value,
            onClose: closeModals
          }, null, 8, ["sample", "show"])
        ]))
      : _createCommentVNode("", true),
    (
        selectedSample.value &&
        selectedSample.value.id &&
        selectedSample.value.name &&
        selectedSample.value.fileR1 &&
        selectedSample.value.fileR2
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SampleForm, {
            "bucket-id": null,
            "sample-id": selectedSample.value.id,
            "sample-name": selectedSample.value.name,
            "sample-description": selectedSample.value.description,
            "sample-file-r1": selectedSample.value.fileR1,
            "sample-file-r2": selectedSample.value.fileR2,
            "kit-code": selectedSample.value.kit?.code?.code || '',
            warning: null,
            show: showModalSampleEdit.value,
            onClose: closeModals,
            onCloseAndRefresh: onSampleFormSuccess
          }, null, 8, ["sample-id", "sample-name", "sample-description", "sample-file-r1", "sample-file-r2", "kit-code", "show"])
        ]))
      : _createCommentVNode("", true),
    (
        selectedSample.value &&
        selectedSample.value.name &&
        selectedSample.value.id &&
        props.assocProjectId &&
        props.assocProjectName &&
        props.canEditSampleAssoc
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ProjectSampleAssociationDelete, {
            "sample-name": selectedSample.value.name,
            "sample-id": selectedSample.value.id,
            projectId: props.assocProjectId,
            projectName: props.assocProjectName,
            show: showModalProjectSampleAssociationDelete.value,
            onClose: closeModals,
            onCloseAndRefresh: onProjectSampleAssociationDeleteSuccess
          }, null, 8, ["sample-name", "sample-id", "projectId", "projectName", "show"])
        ]))
      : _createCommentVNode("", true),
    (selectedSample.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(SampleDelete, {
            "sample-name": selectedSample.value.name || '',
            "sample-id": selectedSample.value.id || 0,
            show: showModalSampleDelete.value,
            onClose: closeModals,
            onCloseAndRefresh: onSampleDeleteSuccess
          }, null, 8, ["sample-name", "sample-id", "show"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})